<template>
  <div class="p-base" style="background-color: #ffffff">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-3/5">
        <div class="mb-4" style="margin-bottom: 50px">
          <h3 class="mb-3">Board Title</h3>
          <vs-input required class="w-full board-name" v-model="boardName" />
        </div>
        <div class="my-6">
          <h3 class="mb-3">User visibility option</h3>
          <v-select
            placeholder="People on the board"
            :options="userVisibility"
            v-model="userVisibilityOption"
          >
          </v-select>
        </div>

        <div v-if="allApps && allApps.length > 0" class="mb-base">
          <h3 class="mb-4">Select Apps</h3>
          <vs-row
            v-for="(da, index) in allApps"
            :key="index"
            class="mb-5"
            vs-type="flex"
            vs-justify="space-between"
          >
            <div style="display: flex; align-items: center">
              <span
                class="template-options-btn-icon inline-flex feather-icon text-primary mr-3"
              >
                <img
                  :src="getAppDataById(da).icon"
                  width="30px"
                  height="30px"
                />
              </span>
              <div>
                <h4 v-if="orgData.slug !== 'gala' && da === 'coach'">Coach</h4>
                <h4 v-else>{{ getAppDataById(da).title }}</h4>
                <div v-if="appPrices && appPrices[da]">
                  <div v-if="appPrices[da].pricePerUser != 0">
                    € {{ appPrices[da].pricePerUser }} per User,
                    <span v-if="appPrices[da].timePeriodInMonths === 'NA'"
                      >Onetime</span
                    >
                    <span v-else
                      >per {{ appPrices[da].timePeriodInMonths }} Month(s)</span
                    >
                  </div>
                  <div v-else>Free</div>
                </div>
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <vs-switch
                vs-icon-on="check"
                v-model="appsSelected"
                :vs-value="getAppDataById(da).id"
              >
                <span slot="off">Install</span>
              </vs-switch>
            </div>
          </vs-row>
        </div>

        <div class="float-left mb-base">
          <h3 class="mb-3">Description</h3>
          <div>
            <quill-editor
              class="quill-editor"
              :value="boardDescription"
              :options="editorOption"
              @change="onEditorChange"
            />
          </div>
        </div>

        <div class="float-left w-full mt-20">
          <h4
            v-if="!isAddSkills"
            @click.stop="isAddSkills = true"
            class="mb-base text-primary cursor-pointer"
          >
            <u>+ Add Skills</u>
          </h4>
          <div v-else class="float-left w-full mb-4">
            <h3 class="mb-3">Skills</h3>
            <v-select
              class="w-full mb-4 vselect"
              name="Skill"
              :taggable="true"
              v-model="setSkill"
              :options="skillOptions"
            />
            <div>
              <vs-chip
                class="mr-3"
                @click="removeSkill(index)"
                v-for="(chip, index) in localSkill"
                :key="index"
                closable
              >
                <p class="text-dark">{{ chip }}</p>
              </vs-chip>
            </div>
          </div>

          <h4
            v-if="!isAddPersonality"
            @click.stop="isAddPersonality = true"
            class="mb-base text-primary cursor-pointer"
          >
            <u> + Add Abilities </u>
          </h4>
          <div v-else class="float-left w-full">
            <h3 class="mb-3">Abilities</h3>
            <v-select
              class="w-full mb-4 vselect"
              name="Personality"
              :taggable="true"
              v-model="setPersonality"
              :options="personalityOptions"
            />
            <div>
              <vs-chip
                class="mr-3"
                @click="removePersonality(index)"
                v-for="(chip, index) in localPersonality"
                :key="index"
                closable
              >
                <p class="text-dark">{{ chip }}</p>
              </vs-chip>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col lg:w-2/5 w-full">
        <vx-card v-if="!addFundsForm" no-shadow card-background="#F8F8F8">
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <div class="mb-base">
                <p class="font-semibold mb-3">Number of Users</p>
                <div class="flex justify-between items-center">
                  <span class="font-semibold">
                    <vs-input-number
                      v-model="numberOfUsers"
                      min="0"
                      class="nou-input"
                    />
                  </span>
                </div>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-w="6">
              <div class="mb-base">
                <p class="font-semibold mb-3">Duration (In Months)</p>
                <div class="flex justify-between items-center">
                  <span class="font-semibold">
                    <vs-input-number
                      v-model="numberOfMonths"
                      min="1"
                      class="nou-input"
                    />
                  </span>
                </div>
              </div>
            </vs-col>
          </vs-row>

          <div
            v-if="!Number(priceDetails.netMRP)"
            class="flex justify-between my-base"
          >
            <p class="font-semibold">Perpetual Board</p>
            <vs-switch
              vs-icon-on="check"
              v-model="nonExpiryBoard"
              :vs-value="true"
            >
            </vs-switch>
          </div>
          <div v-else class="flex justify-between my-base">
            <p class="font-semibold">Non-Expiry Board</p>
            <vs-switch
              vs-icon-on="check"
              v-model="nonExpiryBoard"
              :vs-value="false"
              :disabled="true"
            >
            </vs-switch>
          </div>

          <div class="flex justify-between my-base">
            <p class="font-semibold">Available Balance</p>
            <span>€{{ availableBalance }}</span>
          </div>

          <vs-divider />

          <p class="font-semibold mb-3">Price Details</p>
          <div class="flex justify-between mb-2">
            <span class="text-grey">Total Price per User</span>
            <span>€{{ priceDetails.totalPricePerUser }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span class="text-grey">Total Number of Users</span>
            <span>{{ numberOfUsers }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span class="text-grey">Total MRP</span>
            <span>€{{ priceDetails.totalMRP }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span class="text-grey">Discount</span>
            <span class="text-success">-{{ priceDetails.totalDiscount }}€</span>
          </div>
          <div class="flex justify-between mb-2">
            <span class="text-grey">Estimated Tax</span>
            <span>€{{ priceDetails.totalTax }}</span>
          </div>
          <div class="flex justify-between mb-2">
            <span class="text-grey">EMI Eligibility</span>
            <a href="#" class="text-primary">NA</a>
          </div>

          <vs-divider />

          <div
            v-if="numberOfUsers && appsSelected.length"
            class="flex justify-between mb-3"
          >
            <p class="font-semibold">Total</p>
            <span>€{{ priceDetails.netMRP }}</span>
          </div>
          <div v-else class="flex justify-between mb-3">
            <p class="font-semibold">Total</p>
            <span>€0</span>
          </div>

          <!-- <div class="flex justify-between mb-base">
            <p class="font-semibold">Available Balance</p>
            <span>€{{ availableBalance }}</span>
          </div> -->

          <vs-button
            v-if="availableBalance < priceDetails.netMRP"
            class="w-full my-base"
            @click.prevent="addFundsForm = true"
            >Add Funds</vs-button
          >
          <vs-button
            v-else
            class="w-full my-base"
            @click.prevent="createBoard"
            :disabled="!boardName || !appsSelected.length || numberOfUsers == 0"
            >Create Board</vs-button
          >

          <div class="items-center">
            <router-link
              class="font-semibold text-grey"
              :to="{ name: 'org-board-templates' }"
              ><u>Return to Board Templates</u></router-link
            >
          </div>
        </vx-card>
        <vx-card v-else no-shadow card-background="#F8F8F8">
          <div
            v-if="numberOfUsers && appsSelected.length"
            class="flex justify-between mb-3"
          >
            <p>Current Board Price</p>
            <span>€{{ priceDetails.netMRP }}</span>
          </div>

          <vs-divider />

          <add-funds @addFundsSuccess="addFundsForm = false" />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import AddFunds from "../../components/AddFunds.vue";
import boardTemplates from "@/assets/data/board-templates.js";
import marketplaceList from "@/assets/data/marketplace-list.js";
import _ from "lodash";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import allSkills from "@/assets/data/all-skills.js";
import allPersonality from "@/assets/data/all-personality.js";
import vSelect from "vue-select";

export default {
  data() {
    return {
      boardTemplates,
      marketplaceList,
      numberOfUsers: 50,
      numberOfMonths: 1,
      appsSelected: [],
      boardName: null,
      priceDetails: {
        totalPricePerUser: 0,
        discount: 0,
        specialDiscount: 2,
        taxPerUser: 1,
        emiEligibility: false,
      },
      transactions: [],
      addFundsForm: false,
      currency: "eur",
      boardDescription: null,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image"],
          ],
        },
      },
      localSkill: [],
      localPersonality: [],
      skillOptions: allSkills,
      personalityOptions: allPersonality,
      appPrices: {},
      isAddSkills: false,
      isAddPersonality: false,
      nonExpiryBoard: false,
      userVisibility: [
        { label: "Cannot see other people", key: "noUsersView" },
        { label: "Can see names and thumbnail", key: "usersDpView" },
        {
          label: "Can view profile cards",
          key: "talentCardView",
        },
        {
          label: "Can view full profile",
          key: "resumeView",
        },
      ],
      userVisibilityOption: [],
    };
  },
  components: {
    quillEditor,
    AddFunds,
    vSelect,
  },
  computed: {
    _boardId() {
      return this.$route.params.boardId;
    },
    boardId() {
      return this.$store.state.boards.boardCreation.boardId;
    },
    currentBoard() {
      const boardIndex = this.boardTemplates.findIndex((board) => {
        return board.id === this.boardId;
      });
      if (boardIndex !== -1) return this.boardTemplates[boardIndex];
      else return {};
    },
    allApps() {
      if (
        this.currentBoard &&
        this.currentBoard.defaultApps &&
        this.currentBoard.optionalApps
      ) {
        let allApps = [
          ...this.currentBoard.defaultApps,
          ...this.currentBoard.optionalApps,
        ];
        return allApps;
      } else if (this.currentBoard && this.currentBoard.defaultApps) {
        let allApps = this.currentBoard.defaultApps;
        return allApps;
      } else {
        return [];
      }
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    availableBalance() {
      return this.$store.state.payments.availableFunds;
    },
    setSkill: {
      get() {
        return null;
      },
      set(newVal) {
        if (this.localSkill.includes(newVal)) {
          return;
        }

        this.localSkill.push(newVal);
      },
    },
    setPersonality: {
      get() {
        return null;
      },
      set(newVal) {
        if (this.localPersonality.includes(newVal)) {
          return;
        }

        this.localPersonality.push(newVal);
      },
    },
    isNonExpiryBoard() {
      return !Number(this.priceDetails.netMRP);
    },
  },
  watch: {
    currentBoard(newVal) {
      if (newVal && newVal.defaultApps) {
        this.appsSelected = [];
        newVal.defaultApps.forEach((app) => {
          this.appsSelected.push(app);
        });

        this.$store
          .dispatch("payments/fetchAppPrice")
          .then((res) => {
            this.appPrices = res.data;
          })
          .catch((err) => {
            throw err;
          });

        this.boardName = newVal.title;
      }
    },
    appsSelected() {
      this.setPricing();
    },
    couponCode() {
      this.setPricing();
    },
    numberOfUsers() {
      this.setPricing();
    },
    numberOfMonths(newVal, origVal) {
      if (newVal > origVal) {
        this.setPricing({ timePeriodMovement: "ceil" });
      } else {
        this.setPricing({ timePeriodMovement: "floor" });
      }
    },
    orgData(newVal) {
      if (newVal && newVal._id) {
        this.$store.dispatch("payments/fetchFunds", {
          organizationId: newVal._id,
        });
      }
    },
    priceDetails: {
      deep: true,
      handler() {
        if (!Number(this.priceDetails.netMRP)) {
          this.nonExpiryBoard = true;
        } else {
          this.nonExpiryBoard = false;
        }
      },
    },
  },
  methods: {
    generateBoardSlug(boardTitle) {
      let slug = "default";
      if (boardTitle) {
        let r = (Math.random() + 1).toString(36).substring(3);
        slug =
          boardTitle
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "-" +
          r;
      }
      return slug;
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => {
        return app.id === id;
      });
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    createBoard() {
      if (!this.boardName || !this.numberOfUsers || _.isEmpty(this.orgData))
        return;

      this.$vs.loading();

      let members = [];

      if (!_.isEmpty(this.orgData.subAdmins)) {
        members = _.map(this.orgData.subAdmins, (subAdmin) => {
          return {
            email: subAdmin.email,
            userId: subAdmin.userData[0] ? subAdmin.userData[0]._id : "",
            name: subAdmin.userData[0]
              ? `${subAdmin.userData[0].firstName} ${subAdmin.userData[0].lastName}`
              : subAdmin.email.split("@")[0],
          };
        });
      }

      if (!_.isEmpty(this.orgData.admin)) {
        members.push({
          email: this.orgData.admin.email,
          userId: this.orgData.admin._id,
          name: `${this.orgData.admin.firstName} ${this.orgData.admin.lastName}`,
        });
      }

      const payload = {
        title: this.boardName,
        numberOfUsers: this.numberOfUsers,
        numberOfMonths: this.numberOfMonths,
        _boardId: this._boardId,
        installedApps: this.appsSelected,
        status: "active",
        slug: this.generateBoardSlug(this.boardName),
        netMRP: this.priceDetails.netMRP,
        orgSlug: this.orgData.slug,
        members,
        description: this.boardDescription,
        skill: this.localSkill,
        personality: this.localPersonality,
        perpetuality: this.nonExpiryBoard,
        userVisibilityOption: this.userVisibilityOption.key,
      };

      ///////////////////////////////////
      // deduct amount for board
      ///////////////////////////////////
      this.$store.dispatch("payments/createTransaction", {
        organizationId: this.orgData._id,
        userId: this.userData._id,
        amount: this.priceDetails.netMRP,
        boardId: this._boardId,
        currency: "eur",
        fundType: "LOCKED",
        remark: `Add Credits to ${this.boardName} Board`,
        deductFund: true,
        details: {
          numberOfUsers: this.numberOfUsers,
          numberOfMonths: this.numberOfMonths,
          ...this.priceDetails,
        },
        transactionType: "BOARD_TRANSACTION",
      });

      ///////////////////////////////////
      // add credits to board
      ///////////////////////////////////
      this.$store.dispatch("payments/addCreditsToBoard", {
        organizationId: this.orgData._id,
        userId: this.userData._id,
        boardId: this._boardId,
        credits: this.numberOfUsers,
      });

      // Initiate Kanban Creation
      this.$store.dispatch("kanban/createKanbanV2", {
        boardId: this._boardId,
      });

      this.$store
        .dispatch("boards/createBoardPaymentSession", {
          boardObj: payload,
          organizationId: this.orgData._id,
          orgSlug: this.orgData.slug,
        })
        .then((res) => {
          this.$vs.loading.close();
          this.$router.push({
            name: "org-boards-view",
            query: { neworgboard: true },
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          throw err;
        });
    },
    setPricing(params) {
      if (this.numberOfUsers > 0) {
        let timePeriodMovement = "ceil";
        if (params && params.timePeriodMovement === "floor") {
          timePeriodMovement = "floor";
        }

        const payload = {
          appIds: this.appsSelected,
          numberOfUsers: this.numberOfUsers,
          numberOfMonths: this.numberOfMonths,
          timePeriodMovement: timePeriodMovement,
        };

        this.$store
          .dispatch("payments/fetchBoardPrice", payload)
          .then((res) => {
            this.priceDetails.totalPricePerUser = (
              Number(res.data.totalPrice) / Number(this.numberOfUsers)
            ).toFixed(2);
            this.priceDetails.totalMRP = res.data.totalPrice;
            this.priceDetails.totalDiscount = res.data.discount;
            this.priceDetails.totalTax = res.data.taxAmount;
            this.priceDetails.netMRP = res.data.netPrice;
            this.numberOfMonths = res.data.minimumTimePeriodInMonths;
            this.$forceUpdate();
          });
      } else {
        this.numberOfUsers = 0;
        this.priceDetails.totalPricePerUser = 0;
        this.priceDetails.totalMRP = 0;
        this.priceDetails.totalDiscount = 0;
        this.priceDetails.totalTax = 0;
        this.priceDetails.netMRP = 0;
      }
    },
    onEditorChange: _.debounce(function (value) {
      this.boardDescription = value.html;
    }, 466),
    removeSkill(index) {
      this.localSkill.splice(index, 1);
    },
    removePersonality(index) {
      this.localPersonality.splice(index, 1);
    },
  },
  mounted() {
    if (this.currentBoard.defaultApps && this.allApps) {
      this.allApps.forEach((app) => {
        this.appsSelected.push(app);
      });

      this.$store
        .dispatch("payments/fetchAppPrice")
        .then((res) => {
          this.appPrices = res.data;
        })
        .catch((err) => {
          throw err;
        });
    }
  },
  created() {
    this.$store
      .dispatch("boards/fetchBoardDetails", this._boardId)
      .catch((err) => {
        throw err;
      });

    if (this.orgData && this.orgData._id) {
      this.$store.dispatch("payments/fetchFunds", {
        organizationId: this.orgData._id,
      });
    }
  },
  beforeDestroy() {
    this.appsSelected = [];
    this.numberOfUsers = 50;
    this.boardName = null;
  },
};
</script>

<style scoped>
.nou-input.vs-input-number {
  background-color: #ffffff !important;
}

.nou-input.vs-input-number >>> input {
  font-size: 15px;
}
.nou-input.vs-input-number >>> i {
  font-size: 14px !important;
}

.nou-input.vs-input-number >>> button {
  border-radius: 5px !important;
}

button {
  border-radius: 8px !important;
}

.board-name >>> .vs-con-input input.vs-input--input {
  font-size: 20px !important;
}

.coupon-code >>> .vs-con-input input.vs-input--input {
  text-transform: uppercase !important;
}

.vs-con-textarea {
  background: #fbfbfc;
  border: 1px solid #ebedf0 !important;
  box-sizing: border-box;
  border-radius: 6px;
  /*height: 109px;*/
  height: 175px;

  font-weight: normal;
  font-size: 1rem; /*16px*/
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;

  margin-bottom: 0;

  display: flex;
  flex-direction: column;
}

.vs-con-textarea .vs-textarea {
  background: #fbfbfc;
  /*border: 1px solid #EBEDF0!important;*/
  box-sizing: border-box;
  border-radius: 6px;
  /*height: 150px;*/
  height: 175px;

  font-weight: normal;
  font-size: 1rem; /*16px;*/
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;
}

.vs-con-textarea >>> .vs-textarea {
  height: 175px !important;
}

.quill-editor {
  height: 15rem;
}
</style>
